import { render } from "./tkiasupport.vue?vue&type=template&id=e13c8d2e&scoped=true"
import script from "./tkiasupport.vue?vue&type=script&lang=js"
export * from "./tkiasupport.vue?vue&type=script&lang=js"

import "./tkiasupport.vue?vue&type=style&index=0&id=e13c8d2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e13c8d2e"

export default script